/**
 * https://www.iana.org/assignments/media-types/media-types.xhtml
 */
export enum MediaType {
	JSON = 'application/json',
	X_WWW_FORM_URLENCODED = 'application/x-www-form-urlencoded',
}
